<template>
  <b-badge
    class="sr-status-badge"
    :style="style"
    pill
  >
    {{ text }}
  </b-badge>
</template>

<script>

export default {
    name: 'IncidentBadge',
    props: {
        incidents: { type: Number, default: 0 }
    },
    computed: {
        style() {
            return { 'background-color': '#fc6274' }
        },
        color() {
            return '#ffffff'
        },
        text() {
            if (this.incidents > 0) {
                return this.incidents
            } else {
                return ''
            }
        }
    }
}

</script>

<style scoped lang="scss">

.sr-status-badge {
  width: 25px;
}

</style>
